import * as yup from "yup";

export const BaseSchema = {
    first_name: yup.string().label('This field').required().max(100),
    last_name: yup.string().label('This field').required().max(100),
    email: yup.string().label('This field').email().required().max(200),
    job_role: yup.string().label('This field').required().max(200),
    permission_level: yup
    .object()
    .label('This field')
    .typeError("This field is a required")
    .required(),
    ClientType: yup
        .object()
        .label("This field")
        .required()
        .typeError("This field is a required"),
    client_account: yup
    .object()
    .label('This field')
    .required()
    .typeError('This field is a required'),
};